export default "__VITE_ASSET__DWEy$6M4__"